export default __webpack_public_path__ + "static/media/user_lock_icon.86173c77.svg";